import React from 'react';
import { useLocale } from 'locale';
import * as Styled from './styled';

export interface DescriptionProps {
  description: string;
}

export const Description: React.FC<DescriptionProps> = (props) => {
  const { description } = props;
  const { t } = useLocale();

  return (
    <Styled.Root data-auto="description">
      <Styled.Text weight="bold">{t('unitPage.description.header')}</Styled.Text>
      <Styled.DescriptionText>{description}</Styled.DescriptionText>
    </Styled.Root>
  );
};
